import React, { useEffect, useState } from "react";
import { Button, Offcanvas, Modal, Dropdown } from "react-bootstrap";
// import MenuIcon from "../assets/svg/MenuIcon";
import MenuIcon from "../assets/images/icons/menu-toggle.svg";

import WhatsappIcon from "../assets/images/whatsapp-icon.svg";
import TelegramIcon from "../assets/images/telegram-icon.svg";
import FBIcon from "../assets/images/facebook-icon.svg";

import { useLocation } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { logoutUser } from "../redux/auth/actions";

import numberWithCommas from "../utils/numbersWithComma";
import MoonLight from "../assets/images/moon.svg";
import SunLight from "../assets/images/sunny.svg";

import { getNotifications, handleRightSideBar } from "../redux/app/actions";
import { AiOutlineClose } from "react-icons/ai";
import { FaSpinner } from "react-icons/fa";
import WalletImg from "../assets/images/icons/Wallet.svg";
import ProfileImg from "../assets/images/icons/Profile.svg";

import ProfileIconNew from "../assets/images/icons/header/user.png";
import BetIconNew from "../assets/images/icons/header/online-gambling.png";
import AccountStatementIcon from "../assets/images/icons/header/statements.png";
import ReferraltIcon from "../assets/images/icons/header/referral.png";
import KYCIcon from "../assets/images/icons/header/kyc.png";
import SignOutIcon from "../assets/images/icons/header/power.png";
import SupportIcon from "../assets/images/icons/header/customer-support.png";
import GamesSearchModal from "../views/components/GamesSearchModal";
const HeaderAfterLogin = () => {
  const { wallet, user } = useSelector((state) => state.auth);

  const handleClose = () => dispatch(handleRightSideBar(!showRightSideBar));

  const dispatch = useDispatch();
  const { appDetails } = useSelector((state) => state.app);
  const [showLightModeToggle, setShowLightModeToggle] = useState(false);
  const { showRightSideBar } = useSelector((state) => state.app);
  const [websiteNotifications, setWebsiteNotifications] = useState([]);
  const [showNotifications, setShowNotifications] = useState(false);

  const [showToggle, setShowToggle] = useState(true);
  const location = useLocation();
  const [isClassAdded, setIsClassAdded] = useState(false);
  useEffect(() => {
    const isMobile = window.innerWidth <= 768;
    if (location.pathname === "/home" && !isMobile) {
      document.body.classList.add("leftbar-opened");
    } else {
      document.body.classList.remove("leftbar-opened");
    }
  }, [location.pathname]);

  useEffect(() => {
    if (showToggle) {
      document.body.classList.add("header_open");
    } else {
      document.body.classList.remove("header_open");
    }
  }, [showToggle]);

  useEffect(() => {
    setShowToggle(window.screen.width > 992);
    loadNotifications();
    return () => {};
  }, []);

  useEffect(() => {
    if (showLightModeToggle) {
      document.body.classList.add("light-mode");
    } else {
      document.body.classList.remove("light-mode");
    }
  }, [showLightModeToggle]);

  const loadNotifications = async () => {
    // get notifications
    const notifications = await getNotifications();
    if (notifications && notifications?.data?.data) {
      setShowNotifications(true);
      setWebsiteNotifications(notifications?.data?.data);
    }
  };
  const toggleSidebar = () => {
    document.body.classList.toggle("leftbar-opened");
  };
  const toggleClass = () => {
    if (isClassAdded) {
      setIsClassAdded(false);
      localStorage.removeItem("isClassAdded");
      document.body.classList.remove("light-theme");
    } else {
      setIsClassAdded(true);
      localStorage.setItem("isClassAdded", true);
      document.body.classList.add("light-theme");
    }
  };
  return (
    <>
      {(websiteNotifications.length && showNotifications && (
        <div className="marqu">
          <marquee
            onMouseOver={(e) => e.target.stop()}
            onMouseOut={(e) => e.target.start()}
          >
            {websiteNotifications.map((notf, idx) => notf?.content + " ")}
          </marquee>
          <h2 onClick={() => setShowNotifications(false)}>
            <AiOutlineClose />
          </h2>
        </div>
      )) ||
        null}

      <header className="header aftrlgn">
        <div className="top_head">
          <div className="container-fluid">
            <div className="row">
              <div className="col-12">
                <div className="d-flex justify-content-between align-items-center">
                  <div className="d-flex align-items-center LogoSection ">
                    <div className="leftbar_toggle me-3">
                      <Button
                        variant="primary"
                        // onClick={() => handleToggleChange((s) => !s)}
                        onClick={toggleSidebar}
                      >
                        <img src={MenuIcon} alt="toggle menu" />
                      </Button>
                    </div>
                    <div className="logo">
                      <a href="/home">
                        {appDetails?.LOGO_URL ? (
                          <img
                            src={appDetails?.LOGO_URL}
                            alt="Logo"
                            height={26}
                          />
                        ) : (
                          <FaSpinner />
                        )}
                      </a>
                    </div>
                  </div>

                  <div className="headerRight">
                    <div>
                      <GamesSearchModal />
                    </div>
                    <div className="theme-btn  d-md-block d-none">
                      <button
                        type="button"
                        className="btn"
                        onClick={toggleClass}
                      >
                        <img src={SunLight} alt="sun" className="light_theme" />
                        <img
                          src={MoonLight}
                          alt="moon"
                          className="dark_theme"
                        />
                      </button>
                    </div>

                    <div className="deposit-bal-withdraw d-md-flex d-none">
                      <a href="/gatewaylist" className="DepositBtn">
                        D
                      </a>
                      <div className="BalanceSection">
                        <ul>
                          <li>
                            Balance:
                            <span>{wallet?.balance}</span>
                          </li>
                          <li>
                            Cash:
                            <span>{numberWithCommas(wallet?.cash)}</span>
                          </li>
                          <li>
                            Bonus:
                            <span>{numberWithCommas(wallet?.coins)}</span>
                          </li>
                        </ul>
                      </div>
                      <a href="/withdraw" className="WithdrawBtn">
                        W
                      </a>
                    </div>

                    <Dropdown
                      align="end"
                      className="me-2 d-md-none d-block ml-0"
                    >
                      <Dropdown.Toggle variant="success" id="dropdown-basic">
                        <img src={WalletImg} alt="WalletImg" />{" "}
                        <span>{wallet?.balance}</span>
                      </Dropdown.Toggle>
                      <Dropdown.Menu>
                        <Dropdown.Item href="tel:{user?.mobileno}">
                          <b>{user?.mobileNumber}</b>
                        </Dropdown.Item>
                        <Dropdown.Item href="javascript:void(0)">
                          <h6>Balance</h6>
                          <span>{wallet?.balance}</span>
                        </Dropdown.Item>
                        <Dropdown.Item href="javascript:void(0)">
                          <h6>Cash</h6>
                          <span> {numberWithCommas(wallet?.cash)}</span>
                        </Dropdown.Item>
                        <Dropdown.Item href="javascript:void(0)">
                          <h6>Bonus</h6>
                          <span>{numberWithCommas(wallet?.coins)}</span>
                        </Dropdown.Item>
                        <Dropdown.Item href="/gatewaylist" className="deposit">
                          Deposit
                        </Dropdown.Item>
                      </Dropdown.Menu>
                    </Dropdown>

                    <div className="funds d-md-none  me-2">
                      <ul>
                        <li className="">
                          <a href="/gatewaylist" className="deposit">
                            <span className="">Deposit</span>
                          </a>
                        </li>
                      </ul>
                    </div>
                    <Button
                      variant="primary menu-btn d-md-block d-none"
                      onClick={() =>
                        dispatch(handleRightSideBar(!showRightSideBar))
                      }
                    >
                      <img src={ProfileImg} alt="ProfileImg" />
                      {/* <ProfileIcon /> */}
                      {/* <MenuIcon /> */}
                    </Button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <Offcanvas
          show={showRightSideBar}
          onHide={handleClose}
          placement={"end"}
        >
          <Offcanvas.Header closeButton="closeButton" closeVariant="white">
            <Offcanvas.Title>
              <div className="d-flex">
                <div className="profile-img">
                  <img src={ProfileImg} alt="ProfileImg" />
                </div>
                <div className="user-info">
                  <span>{user?.userName}</span>
                  {/* <a href="tel:{user?.mobileno}">{user?.mobileno}</a> */}
                  <a>{user?.mobileNumber}</a>
                </div>
              </div>
            </Offcanvas.Title>
          </Offcanvas.Header>
          <Offcanvas.Body>
            <div className="row">
              <div className="col-6">
                <div className="balance mb-1">Main Balance</div>
              </div>
              <div className="col-6">
                <div className="balance-amount mb-1">
                  {numberWithCommas(wallet?.cash || 0)}
                </div>
              </div>
              <div className="col-6">
                <div className="balance mb-3">Bonus</div>
              </div>
              <div className="col-6">
                <div className="balance-amount mb-3">
                  {numberWithCommas(wallet?.coins) || 0}
                </div>
              </div>
              <div
                className="col-6"
                onClick={() => {
                  window.location.href = "/withdraw";
                }}
              >
                <Button variant="primary  w-100">Withdraw</Button>
              </div>
              <div
                className="col-6"
                onClick={() => {
                  window.location.href = "/gatewaylist";
                }}
              >
                <Button variant="primary w-100">Deposit</Button>
              </div>
            </div>
            <ul className="menu-items">
              <li>
                <a href="/profile">
                  <img src={ProfileIconNew} alt="ProfileIcon" />
                  <span>Profile</span>
                </a>
              </li>
              <li>
                <a href="/mybets">
                  <img src={BetIconNew} alt="BetIconNew" />
                  <span>My Bets</span>
                </a>
              </li>
              <li>
                <a href="/cashier">
                  <img src={AccountStatementIcon} alt="AccountStatementIcon" />
                  <span>Account Statement</span>
                </a>
              </li>
              <li>
                <a href="/bonus">
                  <img src={ReferraltIcon} alt="ReferraltIcon" />
                  <span className="bonus-space">Bonus</span>
                </a>
              </li>
              <li>
                <a href="/referral">
                  <img src={ReferraltIcon} alt="ReferraltIcon" />
                  <span className="bonus-space">Referral</span>
                </a>
              </li>
              <li>
                <a href="/kyc">
                  <img src={KYCIcon} alt="ReferraltIcon" />
                  <span className="bonus-space">KYC</span>
                </a>
              </li>

              <li>
                <a href="/contactus">
                  <img src={SupportIcon} alt="support" />
                  <span>Support Team</span>
                </a>
              </li>
              <li
                onClick={() => {
                  dispatch(logoutUser());
                  handleClose();
                }}
              >
                <a href="#">
                  <img src={SignOutIcon} alt="SignOutIcon" />
                  <span>Sign Out</span>
                </a>
              </li>
            </ul>
            <ul className="social_links">
              <li>
                <a
                  className="panel"
                  href={
                    appDetails?.WHATS_APP_URL != ""
                      ? `https://wa.me/${appDetails?.WHATS_APP_URL}`
                      : "javascript:void(0)"
                  }
                  target={appDetails?.WHATS_APP_URL != "" ? "_blank" : ""}
                >
                  {/* <h2 className="notification-count">2</h2> */}
                  <img src={WhatsappIcon} alt="whats app" />
                </a>
              </li>
              <li>
                <a
                  className="panel"
                  href={
                    appDetails?.TELEGRAM != ""
                      ? appDetails?.TELEGRAM
                      : "javascript:void(0)"
                  }
                  target={appDetails?.TELEGRAM != "" ? "_blank" : ""}
                >
                  <img src={TelegramIcon} alt="telegram" />
                </a>
              </li>
              <li>
                <a
                  className="panel social-icon watsapp"
                  href={
                    appDetails?.FACEBOOK != ""
                      ? appDetails?.FACEBOOK
                      : "javascript:void(0)"
                  }
                  target={appDetails?.FACEBOOK != "" ? "_blank" : ""}
                >
                  <img src={FBIcon} alt="facebook" />
                </a>
              </li>
              <div className="theme-btn  d-md-none d-block">
                <button type="button" className="btn" onClick={toggleClass}>
                  <img src={SunLight} alt="sun" className="light_theme" />
                  <img src={MoonLight} alt="moon" className="dark_theme" />
                </button>
              </div>
              <div>
                <Button
                  className="d-block d-md-none"
                  onClick={() => handleClose()}
                >
                  Back
                </Button>
              </div>
            </ul>
          </Offcanvas.Body>
        </Offcanvas>
      </header>
    </>
  );
};

export default HeaderAfterLogin;
